/**
 * Returns the api URL with the provided path appended
 * @param relativeUrl Specific path under the API root
 * @returns /api/Relative/Url
 */
export function getUrl(relativeUrl: string): string {
  let root = '/api'; //this.appConfigService.getConfig().apiRoot;
  if (!root.endsWith('/')) {
    root += '/';
  }
  if (relativeUrl.startsWith('/')) {
    relativeUrl = relativeUrl.substr(0, relativeUrl.length - 1);
  }
  return root + relativeUrl;
}
